import {ModalBody} from "@/components/modal/index";
import styled from "styled-components";

const ModuleViewModal = ({data}) => {
    return(
        <ModalBody>
            <ModuleViewWrap>
                <img src={data.item.itemImg} />
            </ModuleViewWrap>
        </ModalBody>
    )
}
const ModuleViewWrap  = styled.div`
    
`
export default ModuleViewModal;